import { gql } from "@apollo/client";

export const CREATE_AML_RULE_COMMENT = gql`
  mutation createAmlRuleComment($input: CreateAmlRuleCommentInput!) {
    aml {
      createAmlRuleComment(input: $input) {
        success
      }
    }
  }
`;
